var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.631 0.224235C16.2025 -0.124247 15.5727 -0.0594114 15.2242 0.36905C14.8757 0.797511 14.9406 1.42735 15.369 1.77583L16.1857 2.44003H7.56C3.38473 2.44003 0 5.82476 0 10C0 10.5523 0.447715 11 1 11C1.55228 11 2 10.5523 2 10C2 6.92933 4.4893 4.44003 7.56 4.44003H16.5389L15.3025 5.64344C14.9067 6.02865 14.8982 6.66175 15.2834 7.05752C15.6686 7.45328 16.3017 7.46184 16.6975 7.07663L19.6975 4.15663C19.902 3.95757 20.0117 3.68062 19.999 3.39551C19.9863 3.11041 19.8524 2.84431 19.631 2.66423L16.631 0.224235Z",
    fill: "#0F973D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36902 19.7758C3.79748 20.1243 4.42732 20.0595 4.7758 19.631C5.12428 19.2026 5.05944 18.5727 4.63098 18.2242L3.81434 17.56H12.44C16.6153 17.56 20 14.1753 20 10C20 9.44775 19.5523 9.00003 19 9.00003C18.4477 9.00003 18 9.44775 18 10C18 13.0707 15.5107 15.56 12.44 15.56H3.46111L4.69749 14.3566C5.09325 13.9714 5.10181 13.3383 4.7166 12.9425C4.33138 12.5468 3.69828 12.5382 3.30251 12.9234L0.302515 15.8434C0.0980053 16.0425 -0.0117111 16.3194 0.000993729 16.6046C0.0136986 16.8897 0.147615 17.1558 0.36902 17.3358L3.36902 19.7758Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep2);
export default __webpack_public_path__ + "static/media/ic_step2.760352a7ed02589b85ad2e1bf8461c8a.svg";
export { ForwardRef as ReactComponent };